@if(view.site?.id === 119) {
    <section class="w-full mx-auto bg-white pt-10 pb-15 px-10 dark:bg-gray-900 dark:text-white">
    <h1 class="text-4xl text-center uppercase font-semibold mb-10">Why Choose The Travel Department?</h1>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
        <div
            class="bg-white rounded-lg p-6 transform transition duration-300 hover:-translate-y-2 hover:shadow-xl">
            <mat-icon class="icon-size-8 text-primary-500" [svgIcon]="'heroicons_outline:globe-europe-africa'"></mat-icon>
            <h3 class="text-lg font-semibold text-gray-800 mb-2">Global Destinations</h3>
            <p class="text-gray-600 text-sm">Whether you dream of sun-soaked beaches, vibrant urban hubs, or serene natural escapes, we cover a vast array of destinations.</p>
        </div>
        <div
            class="bg-white rounded-lg p-6 transform transition duration-300 hover:-translate-y-2 hover:shadow-xl">
            <mat-icon class="icon-size-8 text-primary-500" [svgIcon]="'mat_solid:group'"></mat-icon>
            <h3 class="text-lg font-semibold text-gray-800 mb-2">Expert Consultants</h3>
            <p class="text-gray-600 text-sm">Our team of seasoned travel enthusiasts is committed to tailoring your journey to your specific needs, ensuring every trip is one-of-a-kind.</p>
        </div>
        <div
            class="bg-white rounded-lg p-6 transform transition duration-300 hover:-translate-y-2 hover:shadow-xl">
            <mat-icon class="icon-size-8 text-primary-500" [svgIcon]="'mat_solid:attach_money'"></mat-icon>
            <h3 class="text-lg font-semibold text-gray-800 mb-2">Value for Money</h3>
            <p class="text-gray-600 text-sm">Experience the luxury of affordable travel. With our comprehensive range of services and partnerships, we ensure you get the best deals and value.</p>
        </div>
        <div
            class="bg-white rounded-lg p-6 transform transition duration-300 hover:-translate-y-2 hover:shadow-xl">
            <mat-icon class="icon-size-8 text-primary-500" [svgIcon]="'support_agent'"></mat-icon>
            <h3 class="text-lg font-semibold text-gray-800 mb-2">Round-The-Clock Support</h3>
            <p class="text-gray-600 text-sm">Travel with peace of mind, knowing that our 24/7 customer service line is always available to address any queries or concerns.</p>
        </div>
    </div>
</section>
}

@if(view.site?.id === 75) {
    <section class="w-full mx-auto bg-white pt-10 pb-15 px-10 dark:bg-gray-900 dark:text-white">
        <h1 class="text-4xl text-center uppercase font-semibold mb-10">Why Choose Highway Travel?</h1>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
            <div
                class="bg-white rounded-lg p-6 transform transition duration-300 hover:-translate-y-2 hover:shadow-xl">
                <mat-icon class="icon-size-8 text-primary-500" [svgIcon]="'heroicons_outline:globe-europe-africa'"></mat-icon>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Consistently Priced Products</h3>
                <p class="text-gray-600 text-sm">We pride ourselves on delivering a wide range of travel products which are consistently priced right.</p>
            </div>
            <div
                class="bg-white rounded-lg p-6 transform transition duration-300 hover:-translate-y-2 hover:shadow-xl">
                <mat-icon class="icon-size-8 text-primary-500" [svgIcon]="'mat_outline:waving_hand'"></mat-icon>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Built on Strong Values</h3>
                <p class="text-gray-600 text-sm">Our solid agency structure stems from our core values of Good Ethics, Transparency, Honesty.</p>
            </div>
            <div
                class="bg-white rounded-lg p-6 transform transition duration-300 hover:-translate-y-2 hover:shadow-xl">
                <mat-icon class="icon-size-8 text-primary-500" [svgIcon]="'heroicons_outline:globe-europe-africa'"></mat-icon>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Passion for Travel, No Limits</h3>
                <p class="text-gray-600 text-sm">We are passionate about travel and no trip or corporate account is too small (or too large) for us to manage.</p>
            </div>
            <div
                class="bg-white rounded-lg p-6 transform transition duration-300 hover:-translate-y-2 hover:shadow-xl">
                <mat-icon class="icon-size-8 text-primary-500" [svgIcon]="'mat_outline:verified_user'"></mat-icon>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Owner-Managed</h3>
                <p class="text-gray-600 text-sm">Our stores are Owner Managed, ensuring that we will service your travel account like it’s our only one, with excellence, with focused attention to getting you the best travel deals possible.</p>
            </div>
        </div>
    </section>
}